
import { SerfJobStatus } from '@/model';
import Vue from 'vue';

export default Vue.extend({
  name: 'IngestionStatusBadge',

  props: {
    value: { type: String as () => SerfJobStatus, required: true },
    loading: { type: Boolean, default: false },
    xSmall: { type: Boolean, default: false },
  },

  computed: {
    spinnerSize(): number {
      return this.xSmall ? 10 : 30;
    },
  },

  methods: {
    color(status: SerfJobStatus) {
      switch (status) {
        case 'complete':
          return 'green';
        case 'failed':
          return 'red';
        case 'cancelled':
          return 'gray';
        default:
          return 'lightgray';
      }
    },
  },

});
